module.exports = __webpack_public_path__ + "static/pic05.689272b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pic05.jpg
// module id = 488
// module chunks = 114276838955818